import * as React from 'react';
import { CSSTransition } from "react-transition-group";
import './StickyActionBar.scss';

interface IProps {
    showBar : boolean;
    children: any;
    classes?: string;
}

const StickyActionBar = (props: IProps) => {

    const [barClass, setBarClass] = React.useState('');

    const sizeBottomBar = () => {

        const windowWidth = window.innerWidth;
        if (windowWidth >= 1450 && barClass === 'maxed-out') {
            return;
        }
        else if (windowWidth >= 1450 && barClass !== 'maxed-out') {
            setBarClass('maxed-out');
        }
        else if (barClass.length > 0) {
            setBarClass('');
        }
        else {
            return;
        }
    };

    return <CSSTransition
            in={ props.showBar }
            timeout={300}
            classNames="showStickyActionBar"
            unmountOnExit>
            <div className={`row sticky-action-bar ${ barClass } ${ props.classes }`}>
                { props.children }                
            </div>
        </CSSTransition>;

};

StickyActionBar.defaultProps = {
    classes: ''
};

export { StickyActionBar };
